const ACCOUNT_EXPORT_FIELDS = [
  ['name', 'Name'],
  ['accountNumber', 'TSE Account ID'],
  ['id', 'SFDC ID'],
  ['type', 'Type'],
  ['industry', 'Industry'],
  ['phone', 'Phone'],
  ['website', 'Website'],
  ['billingStreet', 'Billing Street'],
  ['billingCity', 'Billing City'],
  ['billingState', 'Billing State'],
  ['billingPostalCode', 'Billing Postal Code'],
  ['billingCountry', 'Billing Country'],
  ['fullBillingAddress', 'Full Billing Address'],
  ['createdDate', 'Created Date']
];

const formatExportValue = (value) => {
  if (value === null || value === undefined) return '';
  return String(value);
};

const getFullBillingAddress = (account) => {
  if (account?.fullBillingAddress) {
    return account.fullBillingAddress;
  }

  return [
    account?.billingStreet,
    account?.billingCity,
    account?.billingState,
    account?.billingPostalCode,
    account?.billingCountry
  ].filter(Boolean).join(', ');
};

export const buildAccountExportRows = (accounts) => {
  return accounts.map((account) => {
    const exportAccount = {
      ...account,
      fullBillingAddress: getFullBillingAddress(account)
    };

    return ACCOUNT_EXPORT_FIELDS.reduce((row, [field, label]) => {
      row[label] = formatExportValue(exportAccount[field]);
      return row;
    }, {});
  });
};

const escapeCsvValue = (value) => {
  const normalized = formatExportValue(value).replace(/"/g, '""');
  return /[",\n]/.test(normalized) ? `"${normalized}"` : normalized;
};

const downloadBlob = (blob, fileName) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};

export const getAccountExportFileBaseName = () => {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  return `triserve-accounts-${timestamp}`;
};

export const exportAccountsAsCsv = (accounts, fileBaseName = getAccountExportFileBaseName()) => {
  const rows = buildAccountExportRows(accounts);
  const headers = ACCOUNT_EXPORT_FIELDS.map(([, label]) => label);
  const csvLines = [
    headers.join(','),
    ...rows.map((row) => headers.map((header) => escapeCsvValue(row[header])).join(','))
  ];

  const csvContent = csvLines.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, `${fileBaseName}.csv`);
};

export const exportAccountsAsExcel = async (accounts, fileBaseName = getAccountExportFileBaseName()) => {
  const rows = buildAccountExportRows(accounts);
  const headers = ACCOUNT_EXPORT_FIELDS.map(([, label]) => label);
  const escapeHtml = (value) => formatExportValue(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const tableHead = headers.map((header) => `<th>${escapeHtml(header)}</th>`).join('');
  const tableRows = rows.map((row) => (
    `<tr>${headers.map((header) => `<td>${escapeHtml(row[header])}</td>`).join('')}</tr>`
  )).join('');
  const workbookHtml = `<!doctype html><html><head><meta charset="utf-8"></head><body><table><thead><tr>${tableHead}</tr></thead><tbody>${tableRows}</tbody></table></body></html>`;
  const blob = new Blob([workbookHtml], { type: 'application/vnd.ms-excel;charset=utf-8;' });

  downloadBlob(blob, `${fileBaseName}.xls`);
};